/*globals window */

import {render, createElement as el} from "rmlibrary/comp";

import {RichIdeasHeader} from "./components/common/header-richideas.html";
import {RichIdeasFooter} from "./components/common/footer-richideas.html";
import {trackPage} from './components/common/hs-track';


export function renderPage(page, container) {
    const C = page === 'footer' ? RichIdeasFooter : RichIdeasHeader;
    render(
        el(C, {}),
        container
    )
}

let trackingTitle = "Rich Ideas";
if (window.RICH_IDEAS_ARTICLE) trackingTitle = `${trackingTitle} - ${window.RICH_IDEAS_ARTICLE}`;
trackPage(trackingTitle);
